import React from 'react';

interface ConfigurableFieldProps {
  fieldName: string;
  formValues: any;
  isFieldVisible: (fieldName: string, formValues: any) => boolean;
  children: React.ReactNode;
}

const ConfigurableField: React.FC<ConfigurableFieldProps> = ({
  fieldName,
  formValues,
  isFieldVisible,
  children,
}) => {
  if (!isFieldVisible(fieldName, formValues)) {
    return (
      <React.Fragment>
        {React.Children.map(children, (child) => {
          if (React.isValidElement(child)) {
            const existingStyle = (child.props as any).style || {};
            return React.cloneElement(child as React.ReactElement<any>, {
              style: { ...existingStyle, opacity: 0.4, pointerEvents: "none" as const },
            });
          }
          return child;
        })}
      </React.Fragment>
    );
  }

  return <>{children}</>;
};

export default ConfigurableField;
